import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function getCustomFilters() {
    try {
        const response = await axios.get(`${REACT_APP_API}/custom_filters`)
        return response.data.data
    } catch (error) {
        throw new Error(error)
    }
}